<template>
  <div class="about">
    <div class="p-5 font-game">ami.vector8.xyz</div>
  </div>
</template>
